module.exports = __webpack_public_path__ + "Icono_Menu_Azul_512px.png";